import Icon, {
  FileProtectOutlined,
  FileTextOutlined,
  LockOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,

} from "@ant-design/icons";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
  CK_TYPE
} from "@constant/constant";
import R from "@routers/R";
import {
  Avatar,
  Button,
  Card,
  Col,
  Dropdown,
  Layout,
  Modal,
  Row,
  Space,
  Typography,
  Image,
  Divider,
  Menu,
  notification
} from "antd";
import { UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Content, Header } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useState } from "react";
import { Cookies, useCookies } from "react-cookie";
import { Link, Redirect, useHistory, useRouteMatch } from "react-router-dom";
import logo1 from "../../src/Image/logoFmr.png";
import { APIEndpointWeb, webapi } from "@client/web";
import ModalPolicy from "@pages/AllModal/ModalPolicy/ModalPolicy";
import NewPasswordLogin from "@pages/AllSetting/NewPasswordLogin";
import ModalTermsOfUse from "@pages/AllModal/ModalCheckEkyc/ModalTermsOfUse/ModalTermsOfUse";
import { error } from "console";
// import logono1 from "../../src/Image/logoFmr.png";

const { Text } = Typography;
const { SubMenu } = Menu;
export interface userDisplay {
  insurer: string;
  name: string;
  ref_code: string;
}
const IsurerLayout: React.FC = (props): JSX.Element => {
  const [goToPath, setGoToPath] = useState("");
  const history = useHistory();
  const route = useRouteMatch();
  const [open, setOpen] = useState(false);
  const [resUserDisplay, setResUserDisplay] = useState<userDisplay>();
  const getCookies = new Cookies();
  const [WindowResize, setWindowResize] = useState(Number);
  const [isModalTermsAndConditions, setIsModalTermsAndConditions] = useState(
    false
  );
  const [isModalOpenPolicy, setIsModalOpenPolicy] = useState(false);
  const [showModalResetPassword, setShowModalResetPassword] = useState(false);
  const [datadefaultSelectedKeys, setdefaultSelectedKeys] = useState(["0"]);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
    CK_TYPE
  ]);
  const [collapsed, setCollapsed] = useState(false);
  const { children } = props;
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };


  const handleGoToPath = (path: string): void => {
    setGoToPath(path);
  };
  const getConfirmSelect = (index: number) => {
    setdefaultSelectedKeys([index.toString()]);
  };
  // useEffect(() => {
  // }, [cookies.shared_token]);
  useEffect(() => {
    getuserdisplay()
    const interval = setInterval(() => {
      checkCookie();
    }, 1500);
    return () => clearInterval(interval);
  }, [route]);


  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const showModal1 = () => {
    setIsModalTermsAndConditions(true);
  };

  const handleOk1 = () => {
    setIsModalTermsAndConditions(false);
  };

  const handleCancel1 = () => {
    setIsModalTermsAndConditions(false);
  };
  const showModal2 = () => {
    setIsModalOpenPolicy(true);
  };

  const handleOk2 = () => {
    setIsModalOpenPolicy(false);
  };

  const handleCancel2 = () => {
    setIsModalOpenPolicy(false);
  };
  const showModal3 = () => {
    setShowModalResetPassword(true);
  };

  const handleOk3 = () => {
    setShowModalResetPassword(false);
  };

  const handleCancel3 = () => {
    setShowModalResetPassword(false);
  };
  const checkpathname = () => {
    switch (window.location.pathname) {
      case "/request":
        return "ส่งคำร้องขอประวัติการรักษา";
      case "/status":
        return "สถานะการดำเนินการ";
      case "/consent":
        return "ประวัติที่เคยขอ";
      default:
        return "สถานะการดำเนินการ";
    }
  };

  const checkpathnameweb = (): string[] | undefined => {
    switch (window.location.pathname) {
      case "/request-list":
        return ['รายการร้องขอประวัติ'];
      case "/request-status":
        return ["สถานะการดำเนินการ"];
      case "/requested-history":
        return ["ประวัติที่เคยขอ"];
      case "/newpassword-login-user":
        return ["ตั้งค่ารหัสผ่านใหม่"];
      default:
        return ["รายการร้องขอประวัติ"];
    }
  };

  function handleMenuClick() {
    webapi.post(`${APIEndpointWeb.logout}`,
      {
        withCredentials: true,
      }
    ).then(() => {

    }).catch((error) => {
      console.log(error.response);
    })
    history.replace("/login");
  }

  const getuserdisplay = async () => {
    var shared_token1 = getCookies.get('shared_token')
    if (shared_token1) {
      try {
        const { data } = await webapi.get(`${APIEndpointWeb.GetUserDisplay}`, {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        })
        setResUserDisplay(data.result);
      } catch (error) {
        if (error === 'Unauthorized') {
          handleMenuClick()
          window.location.replace('/login')
        }
      }
    }
  };

  const checkCookie = () => {
    var type = getCookies.get('type')
    var shared_token1 = getCookies.get('shared_token')
    if (!(Object.keys(cookies).length === 0 && cookies.constructor === Object) && type == "agent" || type == 'user' && shared_token === shared_token1) {
    } else {
      notification.error({
        message: 'คุณใช้งานระบบเกินระยะเวลาที่กำหนด กรุณาเข้าสู่ระบบอีกครั้ง',
      });
      handleMenuClick()
      window.location.replace('/login')
    }
  }

  const showConfirm = (): any => {
    Modal.confirm({
      title: "คุณต้องการออกจากระบบใช่หรือไม่",
      // content: 'ลงชื่อออก',
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      okButtonProps: {
        type: "primary"
      },
      cancelButtonProps: {
        type: "default"
      },
      onOk() {
        setTimeout(() => {
          handleMenuClick();
        }, 1000);
      },
      onCancel() {
        // console.log('can');
      }
    });
  };

  const handleOpenChange = (flag: any) => {
    setOpen(flag);
  };

  const role = getCookies.get("role");
  const shared_token = getCookies.get("shared_token");

  const menu = (
    <Row
      className="mr-4"
      justify="center"
      style={{
        borderRadius: "20px",
        backgroundColor: "#B6D3D6",
        width: "34vh"
      }}
    >
      <Col
        className="pl-2 pr-2"
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        xxl={24}
      >
        <Card
          style={{
            backgroundColor: "#26334A",
            borderRadius: "20px"
          }}
        >
          <Row style={{ textAlign: "center" }}>
            <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Avatar size="large" icon={<UserOutlined />} />
            </Col>
            <Col
              xs={18}
              sm={18}
              md={18}
              lg={18}
              xl={18}
              xxl={18}
              className="mt-2"
            >
              <Text style={{ color: "#ffffff", fontSize: "16px" }}>
                {resUserDisplay?.name}
              </Text>
            </Col>
          </Row>
        </Card>

        <Row className="pt-2 pb-2" style={{ backgroundColor: "#B6D3D6" }}>
          <Menu
            mode="inline"
            style={{ width: 256, backgroundColor: "#B6D3D6 " }}
          >
            <Menu.Item
              key="1"
              onClick={showModal3}
              style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
            >
              <LockOutlined
                style={{
                  fontSize: "20px",
                  color: "#26334A"
                }}

              />
              <Text>เปลี่ยนรหัสผ่าน</Text>
            </Menu.Item>
            <Menu.Item
              key="2"
              onClick={showModal1}
              style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
            >
              <FileProtectOutlined
                style={{
                  fontSize: "20px",
                  color: "#26334A"
                }}
              />
              <Text>ข้อกำหนดการใช้งาน</Text>
            </Menu.Item>
            <Menu.Item
              key="3"
              onClick={showModal2}
              style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
            >
              <SafetyCertificateOutlined
                style={{
                  fontSize: "20px",
                  color: "#26334A"
                }}
              />
              <Text>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Text>
            </Menu.Item>
            <Menu.Item
              key="4"
              onClick={showConfirm}
              style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
            >
              <LogoutOutlined
                style={{
                  fontSize: "20px",
                  color: "#26334A"
                }}
              />
              <Text> ออกจากระบบ </Text>
            </Menu.Item>
          </Menu>
        </Row>
        <Modal
          title="ข้อกำหนดการใช้งาน FMR"
          // width='540px'
          // className="modal-left"
          visible={isModalTermsAndConditions}
          onOk={handleOk1}
          onCancel={handleCancel1}
          footer={
            <Button type="primary" size="middle" onClick={handleCancel1}>
              ปิด
            </Button>
          }
        >
          <ModalTermsOfUse />
        </Modal>
        <Modal
          title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
          // width='540px'
          // className="modal-left"
          visible={isModalOpenPolicy}
          onOk={handleOk2}
          onCancel={handleCancel2}
          footer={
            <Button type="primary" size="middle" onClick={handleCancel2}>
              ปิด
            </Button>
          }
        >
          <ModalPolicy />
        </Modal>
        <Modal
          // className="modal-left"
          visible={showModalResetPassword}
          onOk={handleOk3}
          onCancel={handleCancel3}
          footer={null}
        >
          <NewPasswordLogin />
        </Modal>
      </Col>
    </Row>
  );

  return (
    <>
      {goToPath ? <Redirect to={goToPath} /> : null}
      {WindowResize < 1024 && (
        <Content>
          <Row className="layout-100" justify="center">
            <Col xs={24} sm={24} md={24} lg={10} xl={10} xxl={10}>
              <Row
                className="font-header"
                style={{ backgroundColor: "#147F8B", textAlign: "center" }}
              >
                <Col
                  className="pt-5 "
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <Text style={{ color: "white" }}>{checkpathname()}</Text>
                  <Row className="mt-3">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Menu
                        className="p-3 font-menu"
                        // mode="horizontal"
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "20px 20px 0px 0px"
                        }}
                      >
                        <Menu.Item
                          style={{ color: "black" }}
                          onClick={(): void => {
                            handleGoToPath(R.HomeRouter.request.link);
                          }}
                          key="1"
                        >
                          {window.location.pathname === "/request" ? (
                            <Text style={{ color: "#147F8B" }}>
                              {" "}
                              ขอประวัติใหม่{" "}
                            </Text>
                          ) : (
                            "ขอประวัติใหม่"
                          )}
                        </Menu.Item>
                        <Menu.Item
                          style={{ color: "black" }}
                          onClick={(): void => {
                            handleGoToPath(R.HomeRouter.status.link);
                          }}
                          key="2"
                        >
                          {window.location.pathname === "/status" ? (
                            <Text style={{ color: "#147F8B" }}> สถานะ </Text>
                          ) : (
                            "สถานะ"
                          )}
                        </Menu.Item>
                        <Menu.Item
                          style={{ color: "black" }}
                          onClick={(): void => {
                            handleGoToPath(R.HomeRouter.consent.link);
                          }}
                          key="3"
                        >
                          {window.location.pathname === "/consent" ? (
                            <Text style={{ color: "#147F8B" }}>
                              {" "}
                              ประวัติที่เคยขอ{" "}
                            </Text>
                          ) : (
                            "ประวัติที่เคยขอ"
                          )}
                        </Menu.Item>
                      </Menu>
                      <Divider
                        style={{
                          marginBottom: 0,
                          marginTop: 0,
                          maxWidth: "auto"
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              {children}
            </Col>
          </Row>
        </Content>
      )}

      {WindowResize > 1024 && (
        <Row style={{ minHeight: "100vh" }}>
          <Sider
            collapsed={collapsed}
            style={{
              backgroundColor: "#4EA5B2",
              boxShadow: "1px 4px 10px 1px rgba(0, 0, 0, 0.25)"
            }}
            width={280}
          >
            <Row>
              <Col
                className="pt-4 pr-3 pl-3 pb-5"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                <Space
                  direction="vertical"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Image
                    preview={false}
                    src={logo1}
                    width="200px"
                    height="70px"
                  />
                </Space>
              </Col>
            </Row>
            <Row>
              <Col
                className="p-3"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                {window.location.pathname === "/request-list" ? (
                  <Button
                    block
                    size="large"
                    key="1"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requestlist.link);
                    }}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      border: "none",
                    }}> <Text style={{ color: "#056839" }}>รายการร้องขอประวัติ</Text></Button>
                ) : (
                  <Button block
                    size="large"
                    key="1"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requestlist.link);
                    }}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#005A67",
                      border: "none",
                    }}><Text style={{ color: "#ffffff" }}> รายการร้องขอประวัติ</Text></Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col
                className="p-3"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                {window.location.pathname === "/request-status" ? (
                  <Button block
                    key="2"
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requeststatus.link);
                    }}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      border: "none",
                    }}><Text style={{ color: "#056839" }}>สถานะการดำเนินการ</Text></Button>
                ) : (
                  <Button block
                    key="2"
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requeststatus.link);
                    }}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#005A67",
                      border: "none",
                    }}> <Text style={{ color: "#ffffff" }}>สถานะการดำเนินการ</Text></Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col
                className="p-3"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                {window.location.pathname === "/requested-history" ? (
                  <Button
                    key="3"
                    block
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requestedhistory.link);
                    }}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      border: "none",
                    }}> <Text style={{ color: "#056839" }}>ประวัติที่เคยขอ</Text></Button>
                ) : (
                  <Button block
                    key="3"
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.requestedhistory.link);
                    }}
                    style={{
                      borderRadius: "20px",

                      backgroundColor: "#005A67",
                      border: "none",
                    }}>  <Text style={{ color: "#ffffff" }}>ประวัติที่เคยขอ</Text></Button>
                )}
              </Col>
            </Row>
            <Button
              size="large"
              style={{
                borderRadius: "10px",
                backgroundColor: "#005A67",
                border: "none",
                color: "#ffffff",
                position: "fixed",
                bottom: 0,
                left: 0,
                marginLeft: "65px",
                marginBottom: "30px"
              }}
            >
              <a
                target="_blank"
                href="https://docs.google.com/document/d/1EjTS9qaYvQwsbXfAg-dTyA23A8ABiYq3ggG5k8guZ9c/edit#heading=h.3rlq0vcpbyok"
              >
                คู่มือการใช้งาน&nbsp;
                <FileTextOutlined style={{ color: "#ffffff" }} />
              </a>
            </Button>
          </Sider>

          <Layout
          >
            <Header
              style={{
                boxShadow: "2px 2px 15px rgba(0, 0, 0, 0.25)"
              }}
            >
              <Row justify="space-between">
                <div
                  className="ml-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px"
                  }}
                >
                  <Text
                    style={{
                      color: " #147F8B",
                      fontSize: "20px",
                      fontWeight: "bold"
                    }}
                  >
                    {" "}
                    {checkpathnameweb()}
                  </Text>
                </div>
                <div
                  className="mr-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px"
                  }}
                >
                  <Space size={40}>
                    <Space
                      direction="vertical"
                      className="space-gap"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Text
                        className="font-description"
                        style={{ color: "#147F8B", fontSize: "16px" }}
                      >
                        {resUserDisplay?.name}
                      </Text>
                    </Space>
                    <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                      {" "}
                      |
                    </Text>

                    <Dropdown
                      overlay={menu}
                      overlayStyle={{ paddingTop: "25px" }}
                      placement="bottomRight"
                    >
                      <Avatar
                        style={{ cursor: "pointer" }}
                        size="large"
                        icon={<UserOutlined />}
                      />
                    </Dropdown>
                  </Space>
                </div>
              </Row>
            </Header>
            <Content>{children}</Content>
          </Layout>
        </Row>
      )}

    </>
  );
};

export default IsurerLayout;
